import { motion } from 'framer-motion'
import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ROOMS_ROUTE } from '@/lib/constants'

export function HeroSection() {
  const { t } = useTranslation()

  const handleScrollDown = () => {
    document.getElementById('welcome')?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section
      data-hero
      className="relative flex min-h-[100svh] items-center justify-center overflow-hidden"
      style={{ paddingTop: '300px', paddingBottom: '150px' }}
    >
      {/* Background image with fixed/parallax attachment */}
      <div className="absolute inset-0">
        <img
          src="/images/nuva/hero/hero-habitaciones-page.jpeg"
          alt="Hotel Boutique Nueva Valladolid — Comayagua, Honduras"
          className="absolute inset-0 h-full w-full object-cover"
          fetchPriority="high"
        />
        {/* Dark overlay at 30% opacity matching real site */}
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Centered content */}
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6">
        {/* H1 — VeniceBridge display font, 64px, white */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
          className="font-heading text-5xl font-normal text-white md:text-6xl lg:text-7xl"
          style={{ fontWeight: 400 }}
        >
          {t('hero.title')}
        </motion.h1>

        {/* Subtitle — Montserrat, white */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5, ease: 'easeOut' }}
          className="mt-4 font-sans text-base text-white/90 sm:mt-6 sm:text-lg md:text-xl"
        >
          {t('hero.subtitle')}
        </motion.p>

        {/* Single CTA button — outline pill, white border, white text */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8, ease: 'easeOut' }}
          className="mt-8 flex items-center justify-center sm:mt-10"
        >
          <Link
            to={ROOMS_ROUTE}
            className="inline-flex items-center justify-center border border-white bg-transparent font-sans text-sm font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-[#F3EADB] hover:text-[#0F2966]"
            style={{
              borderRadius: '100px',
              width: '200px',
              height: '50px',
            }}
          >
            Reservar Ahora
          </Link>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.button
        onClick={handleScrollDown}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 1.2 }}
        className="absolute bottom-8 left-1/2 hidden -translate-x-1/2 cursor-pointer text-white/80 hover:text-white sm:block"
        aria-label={t('hero.scroll', { defaultValue: 'Scroll' })}
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
          className="flex flex-col items-center gap-2"
        >
          <span className="font-sans text-xs uppercase tracking-widest">
            {t('hero.scroll', { defaultValue: 'Descubrir' })}
          </span>
          <ChevronDown className="h-6 w-6" />
        </motion.div>
      </motion.button>
    </section>
  )
}
